'use client';

import React, { type HTMLAttributes } from 'react';
import { css } from 'styled-components';
import { useOffersContext } from '@/app/components/hotel-detail/OffersProvider';
import { HotelPageSimilarHotelsSectionContent } from '@/app/components/hotel-detail/HotelPageSimilarHotelsSectionContent';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useFetchHotelStatic } from './hooks/useFetchHotelStatic';
import { useUrlSearchParams } from './UrlSearchParamsProvider';
import customCss from './css/customCss';

export type HotelPageSimilarHotelsSectionProps = HTMLAttributes<HTMLElement>;

const brandsBlackList: BrandTypes[] = ['melia', 'palladium', 'playasol'];

function shouldShowSimilarHotelsSection(brand: BrandTypes): boolean {
  return !brandsBlackList.includes(brand);
}

export default function HotelPageSimilarHotelsSection(props: HotelPageSimilarHotelsSectionProps) {
  const { offersData } = useOffersContext();
  const { data: staticDataHotel } = useFetchHotelStatic();
  const { staticData } = usePageWrapperData();
  const { isTrain } = useUrlSearchParams();
  const price = offersData?.cheapestFilteredMealPlan?.finalTotalPrice;
  const noRoomsAvailable = offersData?.noAvailableRooms;
  const gridArea = noRoomsAvailable ? 'similar-hotels' : 'similar-hotels-bottom';

  return !isTrain && shouldShowSimilarHotelsSection(staticData.domainValues?.brand as BrandTypes) ? (
    <HotelPageSimilarHotelsSectionContent
      {...props}
      style={{ gridArea }}
      css={css`
        background-color: white;

        @media ${customCss.breakpoints.sm} {
          background-color: inherit;
        }
      `}
      noRoomsAvailable={noRoomsAvailable}
      price={price}
      rating={staticDataHotel?.hotelOpinion?.rating}
      hotelCoordinates={staticDataHotel?.coordinates}
    />
  ) : null;
}
